module.exports = __webpack_public_path__ + "img/mkz.473da1db.jpg";